import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import oaklandlogo from "../../assets/new_logo.png";
import { languageJson } from "src/StringVariable";

const PdfGeneratorVessel = ({
  reportData,
  fileName,
  formatRow,
  getSectionData,
  ...props
}) => {
  const generatePDF = () => {
    const doc = new jsPDF("p", "pt");

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    let startY = 90;

    const generatedTime = () => {
      const time = moment().tz("America/Los_Angeles");
      return time.isValid() ? time.format("L h:mm A") : "-";
    };

    const addHeader = () => {
      doc.addImage(oaklandlogo, "PNG", 40, 20, 40, 40);

      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      doc.setTextColor(0);
      doc.text("Oakland Portal - Port of Oakland", 90, 35);

      doc.setFontSize(12);
      doc.setFont(undefined, "normal");
      doc.text("Daily Vessel Status", 90, 55);
    };

    const addFooter = () => {
      const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
      const totalPages = doc.internal.getNumberOfPages();

      doc.setDrawColor(200);
      doc.line(40, pageHeight - 20, pageWidth - 40, pageHeight - 20);

      doc.setFontSize(9);
      doc.setTextColor(100);

      // Left
      doc.text(`Report Generated on : ${generatedTime()}`, 40, pageHeight - 8);

      // Center
      doc.text(
        `Page ${pageNumber} of ${totalPages}`,
        pageWidth / 2,
        pageHeight - 8,
        {
          align: "center",
        }
      );

      doc.text(
        "https://oaklandportal.portofoakland.com",
        pageWidth - 40,
        pageHeight - 8,
        {
          align: "right",
        }
      );
    };

    const getColumns = (category) => {
      switch (category.toLowerCase()) {
       case "vessels at berth (arrived)":
          return ["Vessel Name", "Berth", "Terminal", "Arrived at Berth"];

      case "vessels at anchorage (inbound)":
          return [
            "Vessel Name",
            "Navigation Status",
          //  "Berth",
            "Terminal",
            "Arrived at Anchor",
            "Projected Arrival (MTO Vessel Schedule)",
          ];

       case "vessels en route (< 48 hours)":
          return [
            "Vessel Name",
            "Terminal",
            "Projected Arrival (MTO Vessel Schedule)",
          //  "First Available Date",
          ];

        default:
          return ["Vessel Name"];
      }
    };

    addHeader();

    reportData.forEach((section, index) => {
      const category = section.category;
      const columns = getColumns(category);
      const vessels = getSectionData(section);

      // Section Header
      doc.setFillColor(91, 155, 213);
      doc.rect(40, startY, pageWidth - 80, 20, "F");

      doc.setTextColor(0);
      doc.setFontSize(11);
      doc.setFont(undefined, "bold");

      doc.text(section.category.toUpperCase(), pageWidth / 2, startY + 14, {
        align: "center",
      });

      startY += 25;

      let rows = [];

      if (vessels?.length > 0) {
        rows = vessels.map((item) => {
          const rowObj = formatRow(item, category);

          return columns.map((col) => rowObj[col] || "-");
        });
      } else {
        rows = [["No Data Available", ...Array(columns.length - 1).fill("")]];
      }

      doc.autoTable({
        startY,
        head: [columns],
        body: rows,

        margin: {
          top: 90,
          bottom: 40,
          left: 40,
          right: 40,
        },

        styles: {
          fontSize: 9,
          cellPadding: 6,
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
          overflow: "linebreak",
        },

        headStyles: {
          fillColor: [189, 215, 238],
          textColor: 0,
          halign: "center",
          fontStyle: "bold",
        },

        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },

        theme: "grid",

        didDrawPage: () => {
          addFooter();
        },

        didParseCell: (data) => {
          if (data.row.raw && data.row.raw[0] === "No Data Available") {
            data.cell.colSpan = columns.length;
            data.cell.styles.halign = "center";
            data.cell.styles.fontStyle = "bold";
          }
        },
      });

      startY = doc.lastAutoTable.finalY + 30;

      // Page Break
      if (startY > pageHeight - 150 && index !== reportData.length - 1) {
        doc.addPage();
        addHeader();
        startY = 90;
      }
    });

    // Bottom Link
    let finalY = startY + 10;

    if (finalY > pageHeight - 40) {
      doc.addPage();
      addHeader();
      finalY = 60;
    }

    doc.setFontSize(10);
    doc.setTextColor(0);

    const text = "Find full schedule in the";

    doc.text(text, 40, finalY);

    doc.setTextColor(0, 0, 255);

    doc.textWithLink(
      "Oakland Portal - Port of Oakland",
      40 + doc.getTextWidth(text) + 5,
      finalY,
      {
        url: "https://oaklandportal.portofoakland.com",
      }
    );

    doc.save(`${fileName}.pdf`);
  };

  return (
    <div>
      <button
        onClick={generatePDF}
        className={`btn btn-primary ${props.buttonClass}`}
      >
        {props.buttonTitle || languageJson.generate_pdf_txt}
      </button>
    </div>
  );
};

export default PdfGeneratorVessel;
